import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import $ from 'jquery';
import { useDispatch, useSelector } from 'react-redux';
import LocationNotFound from './modals/LocationNotFound';
import NavigationAppSelection from './modals/NavigationAppSelection';
import { ModalComponent } from '../types/modal';
import { resetModal } from '../store/slices/uiSlice';
export const ModalMap = {
    [ModalComponent.LocationNotFound]: LocationNotFound,
    [ModalComponent.NavigationAppSelection]: NavigationAppSelection,
};
const Modal = () => {
    const modalState = useSelector((state) => state.ui.modal);
    const modalRef = useRef(null);
    const dispatch = useDispatch();
    const ModalComponent = modalState.component ? ModalMap[modalState.component] : null;
    const resetCurrentModal = () => {
        dispatch(resetModal());
    };
    useEffect(() => {
        if (!modalRef.current) {
            return;
        }
        $(modalRef.current).modal(modalState.isVisible ? 'show' : 'hide');
        if (modalState.isVisible) {
            window.dataLayer.push({
                event: 'popupDisplay',
                popupDisplayContent: modalState.component,
            });
        }
    }, [modalState.isVisible]);
    useEffect(() => {
        if (!modalRef.current) {
            return;
        }
        $(modalRef.current).on('hidden.bs.modal', () => {
            resetCurrentModal();
        });
    }, []);
    return (_jsx("div", { ref: modalRef, className: "modal fade", tabIndex: -1, role: "dialog", "aria-hidden": "true", children: _jsx("div", { className: "modal-dialog modal-dialog-centered", role: "document", children: _jsx("div", { className: "modal-content", children: ModalComponent && _jsx(ModalComponent, { ...modalState.params }) }) }) }));
};
export default Modal;
